import { FC, useEffect, useRef, useState } from 'react';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Table from '@/common/components/Data/V2Table';
import styles from '../index.module.less';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { getExpansionTaskList } from '@/common/api/expandStore/expansiontask';
import { useBigdataFn } from '@/common/utils/bigdata';
import AdaptiveTaskDetail from '../../AdaptiveTaskDetail';

/**
 * @Description 加盟商的任务列表
 */
const TaskList: FC<{
  franchiseeId: string;
  taskTemplateCode: string;
  refresh: () => void;
  expansionTaskAlias: string;
}> = ({
  franchiseeId,
  taskTemplateCode,
  refresh,
  expansionTaskAlias,
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [filters, setFilters] = useState<any>({}); // 筛选参数
  const detailRef: any = useRef();

  useEffect(() => {
    // 刷新列表
    franchiseeId && setFilters({
      franchiseeId,
    });
  }, [franchiseeId]);

  /**
   * @description 加载表格数据
   */
  const loadData = async(params: any) => {
    const { objectList, totalNum } = await getExpansionTaskList(params);
    return {
      dataSource: isArray(objectList) ? objectList : [],
      count: totalNum,
    };
  };

  /**
   * @description 点击名称查看详情
   * @param record 当前选中点击某一行的数据
   */
  const onClickDetail = (record) => {
    (detailRef.current as any).handleTaskDetail(record.id);

    bigdataFn('034fb197-acf3-4c95-acad-16698a27ec4b', '拓店任务', '点击了拓店任务', { op_block: '', op_event: ``, });
  };

  /**
     * @description 重新加载
     */
  const reload = () => {
    setFilters({ ...filters });
    refresh?.();
  };

  const defaultColumns = [{
    key: 'name',
    title: `${expansionTaskAlias || '任务'}名称`,
    width: 317,
    importWidth: true,
    render: (value, record) => {
      return isNotEmptyAny(value) ? (
        <span className={styles.name} onClick={() => onClickDetail(record)}>{value}</span>
      ) : '-';
    },
  }, {
    key: 'statusName',
    title: `${expansionTaskAlias || '任务'}状态`,
    width: 300,
    render: (value) => isNotEmptyAny(value) ? value : '-',
  }, {
    key: 'manager',
    title: '开发人员',
    width: 300,
    render: (value) => isNotEmptyAny(value) ? value : '-',
  }];

  return (
    <div className={styles.taskList} >
      <V2Title type='H2' text={expansionTaskAlias || '拓店任务'} divider/>
      {taskTemplateCode && <V2Table
        filters={filters}
        rowKey='id'
        defaultColumns={defaultColumns}
        hideColumnPlaceholder
        onFetch={loadData}
        pageSize={10}
        paginationConfig={{
          pageSizeOptions: [10, 20, 50, 100],
        }}
        scroll={{ y: 550 }}
        className='mt-16'
      />}

      <AdaptiveTaskDetail
        ref={detailRef}
        reload={() => {
          taskTemplateCode === 'standardAndClusterA' ? reload() : refresh?.();
        }}
      />
    </div>
  );
};

export default TaskList;
